import { render, staticRenderFns } from "./list.view.vue?vue&type=template&id=f28f487c&scoped=true"
import script from "./list.view.vue?vue&type=script&lang=js"
export * from "./list.view.vue?vue&type=script&lang=js"
import style0 from "./list.view.vue?vue&type=style&index=0&id=f28f487c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f28f487c",
  null
  
)

export default component.exports